import React, { useState, useEffect } from 'react';
import { makeStyles, createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';

import { List, ListItem, ListItemText, IconButton, Typography, Grid, Divider, Button, Box, Card, CardActions, CardContent } from "@material-ui/core";
import NumberFormat from 'react-number-format';

import { Link, useHistory } from 'react-router-dom'
import { DialogCompanyApproval, DialogConfirm } from './Dialog';

import { COLORS } from './Theme'
import { useSnackbar } from 'notistack';
import ToastStr from '../request/toastStr';
import Select from 'react-select';

// import { getMember, makeURL } from '../request/request'
import axios from 'axios';

import { member as v_member, basic, Values, SNACKBAR_TIME, member } from '../request/values';
import { TitleBackBar } from './header/TitleBar';

const SERVER = basic.server;


const useStyles = makeStyles((theme) => ({
    button: {
        height: 60,
        margin: theme.spacing(3, 0, 2),
        borderRadius: '27px',
        boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        border: 'solid 0.5px #cfd4d9',
        backgroundColor: `${COLORS.PUMPKIN}`
    },
    buttonText: {
        color: `${COLORS.WHITE}`,
        fontFamily: 'NanumB',
        marginLeft: '2vw',
    },
    teamBox: {
        width: '100%',
        marginTop: 20,
        "& #title": {
            color: `${COLORS.CHARCOAL_GREY}`,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
            fontSize: '6vw'
        },
    },
    list: {
        padding: '1.5vh 8px',
        [theme.breakpoints.up("md")]: {
          padding: '1.5vh 26px',
      },
    },

    memberList: {
        height:'7vh',
        //margin: theme.spacing(3, 0, 2),
        marginBottom: '3vh',
        borderRadius: '27px',
        boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        border: 'solid 0.5px #cfd4d9',
        backgroundColor: `${COLORS.WHITE}`,
        [theme.breakpoints.up("md")]: {
          height:'8.5vh',
          borderRadius: '50px',
      },
    },
    memberText: {
        //color: `${COLORS.WHITE}`,
        ...theme.typography.subtitle2,
        marginLeft: '2vw',
    },
    edit_button: {
        borderRadius: '27px',
        border: 'solid 0.5px #cfd4d9',
        //backgroundColor: `${COLORS.PUMPKIN}`
    },
    select:{
        width: '30vw',
        marginRight: '3vw',
        backgroundColor: `${COLORS.WHITE}`,
    },

}));

type iMemberList = {
    member_email: string,
    member_name: string,
    grade: string,
}

const CompanyEditMember: React.FC<any> = props => {
    const classes = useStyles();
    let history = useHistory();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const { member } = props;

    const [memberList, setMemberList] = useState<iMemberList[]>([]);
    const [approvalDialog, setApprovalDialog] = useState<boolean | number>(false)

    let grade: any;
    if(member.companyType === "M"){
        grade = [
            { value: 'purchase', label: '구매담당자' },
            { value: 'sale', label: '판매담당자' },
            { value: 'production', label: '생산담당자' },
        ]
    }
    else if(member.companyType === "D"){
        grade = [
            { value: 'purchase', label: '구매담당자' },
            { value: 'sale', label: '판매담당자' },
            { value: 'production', label: '분해담당자'},
        ]
    }

    const handleClose = (key: string) => {
        if (key === 'approvalDialog')
            setApprovalDialog(prevState => false);
    };

    const handleApprovalOpen = (index: number) => {
        console.log('open', index)
        if (approvalDialog === false) {
            setApprovalDialog(prevState => index);
        }
    }

    const postUserCompanyUpdate = (grade: string) => {
        if (approvalDialog !== false) {
            axios({
                method: "POST",
                data: {
                    email: memberList[approvalDialog as number].member_email,
                    companyNum: member.companyNum,
                    grade: grade,
                },
                withCredentials: true,
                url: SERVER + v_member.member + v_member.company_update,
            }).then((res) => {
                return res.data
            }).then((data: any) => {
                console.log(data)
                if (data.code === Values.SUCCESS_CODE) {
                    enqueueSnackbar(ToastStr.COMPANY_MEMBER_UPDATE_SUCCESS_STR, { variant: "success", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                    //getAppList()
                } else {
                    enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: "error", autoHideDuration: SNACKBAR_TIME, translate: "no" })
                }
            })
        }
        handleClose('approvalDialog')
    }

    const getCompanyMember = () => {
        let url = new URL(basic.server + v_member.member + v_member.company_member);
        let params = { 'companyNum': member.companyNum }
        url.search = new URLSearchParams(params).toString();
        axios({
            method: "GET",
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data) => {
                console.log(data.employees);
                setMemberList(data.employees);
            })
    }

    useEffect(() => {
        getCompanyMember()
    }, [])

    return (
        <div className='content'>
            <TitleBackBar history={history} title="팀원 수정하기" titleIcon="profile_green" />
            <div className={classes.teamBox}>

                <List className={classes.list}>
                    {memberList != null && memberList.map((item: any, index: number) => {
                        return <AppListItem name={item.member_name} approval={() => handleApprovalOpen(index)} />
                    })}
                </List>
            </div>
            <DialogCompanyApproval
                open={approvalDialog === false ? false : true}
                handleClose={() =>handleClose('approvalDialog')}
                memberName={approvalDialog === false ? '' : memberList[approvalDialog as number].member_name}
                companyType={member.companyType}
                noConfirm={() =>handleClose('approvalDialog')}
                yesConfirm={postUserCompanyUpdate}
            />
        </div>

    )
}



const AppListItem: React.FC<any> = props => {

    const classes = useStyles();
    const { name,  approval } = props

    return (
        <ListItem className={classes.memberList}>
            <Box flexGrow={1} className={classes.memberText}>{name}</Box>
            <Box>
              <Button onClick={approval} className={classes.edit_button}>
                <Typography variant='body1'>수정</Typography>
              </Button>
            </Box>
        </ListItem>
    )
}

export default CompanyEditMember;